<template>
  <div>
    <br />
    <br />
    <br />
    <br />
    <div class="container-fluid mt--6">
      <div class="row">

        <div class="col-xl-12">
          <h6 class="heading-small text-muted mb-4">Set new password</h6>

          <div class="pl-lg-4">
            <div class="row">
              <div class="col-lg-6">
                <base-input
                  type="password"
                  rules="required"
                  label="Old password"
                  placeholder="Old password"
                  v-model="pwd.old"
                  name="oldpassword"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <base-input
                  type="password"
                  label="New password"
                  placeholder="New password"
                  v-model="pwd.new"
                  name="newpassword"
                  :rules="pwdrule"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <base-input
                  type="password"
                  label="Retype password"
                  placeholder="Retype password"
                  v-model="pwd.renew"
                  name="retypepassword"
                  :rules="{is: pwd.new, required: true}"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <base-button block type="primary" @click.prevent="onSave">Update</base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Encrypt } from "../../services/crypto";
import { GetUser, Update, nophoto, ChangePassword } from "../../services/user";
import store from "../../store";
import { Modal, BaseAlert } from "@/components";
export default {
  props: {
    id: String
  },
  data() {
    return {
      pwd: {
        new: "",
        old: "",
        renew: ""
      },
      pwdrule: {
        required: true,
        min: 5,
        max: 20
      },
      status: ""
    };
  },
  methods: {
    onSave() {
      var pwd = {};
      pwd.id = this.$store.state.user.id;
      pwd.new = Encrypt(this.pwd.new, this.$store.state.user.pwdtoken).key;
      pwd.old = Encrypt(this.pwd.old, this.$store.state.user.pwdtoken).key;
      // console.log(pwd);
      ChangePassword(pwd).then(response => {
        // console.log(response.data)
        if (response.data.result.changed === "1") this.notifyVue("success");
        else this.notifyVue("danger");
      });
    }
  }
};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}
</style>
